<template>
  <div class="selected-filters mb-3" v-if="items.length">
    <button class="clear-filters-btn" @click="clearFilters()">
      <font-awesome-icon icon="ban" class="icon"/>Clear Filters
    </button>
    <ul class="selected-filters-list list-unstyled list-inline">
      <li class="filtered-item" v-for="filter in items" :key="filter.id" :title="filter.category + ': ' + filter.name" @click="removeItem(filter)">
        {{ filter.name }}
        <font-awesome-icon icon="times" size="sm" fixedWidth class="icon"/>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";
.filtered-item {
  background: $ui-gray;
  color: #fff;
  padding: 3px 8px 3px 10px;
  border-radius: 50px;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;

  .icon {
    margin-left: 10px;
  }

  & + .filtered-item {
    margin-left: 5px;
  }

  &:hover {
    background-color: $ui-green;
  }
}

.clear-filters-btn {
  background: none;
  border: none;
  padding: 0px;
  margin-bottom: 10px;
  font-size: 0.9rem;

  .icon {
    margin-right: 5px;
    font-size: 0.9rem;
    transition: all 200ms;
  }

  &:hover {
    .icon {
      color: $ui-green;
    }
  }
}
</style>

<script>
export default {
  name: "SelectedFilters",
  components: {},
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    clearFilters() {
      //this.items = [];
      this.$emit('clear', []);
    },
    removeItem(item) {
      this.$emit('removefilter', item);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SelectedFilters.vue